<template>
  <v-container fluid class="pa-0 ma-0">
    <v-toolbar class="mb-10">
      <div>
        <v-btn v-print="printObj2">
          <v-icon>mdi-printer</v-icon> Print Page</v-btn
        >
      </div>
    </v-toolbar>
    <div id="printMe2">
      <div class="d-flex justify-space-between align-center" id="logosflex">
        <div id="invoiceimg"><v-img src="../assets/InvoiceHeader.svg" /></div>
        <div id="platformimg">
          <v-img contain class="printlogo" :src="logourl" />
        </div>
      </div>
      <div class="d-flex my-4" id="topboxflex">
        <div class="box whitebg mr-1 pa-4 flex-shrink-1 whitebox" id="whitebox">
          <div class="font-weight-bold"><strong>تاريخ الفاتورة:</strong></div>
          <div>{{ invoicedate }}</div>

          <div class="font-weight-bold mt-4 greyboxsmallmargin">
            <strong>رقم الفاتورة:</strong>
          </div>
          <div>{{ invoicenumber }}</div>
        </div>
        <div class="box greybg ml-1 flex-grow-1 pa-4" id="greybox">
          <div class="d-flex justify-space-between" id="greboxinnerflex">
            <div>
              <div class="font-weight-bold">
                <strong>{{ printto }}</strong>
              </div>
              <div>{{ clientname }}</div>
              <div>{{ clientphone }}</div>
              <div>{{ clientaddress }}</div>
            </div>
            <div>
              <div v-if="clientdelivery !== '1'">
                <div class="font-weight-bold">
                  <strong>طريقة الشحن:</strong>
                </div>
                <div>{{ shippingmethod }}</div>
              </div>
              <div class="greyboxsmallmargin">
                <div class="font-weight-bold mt-4">
                  <strong>{{ printnotes }}</strong>
                </div>
                <div>{{ notes }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box fill-height">
        <v-simple-table class="pa-1" id="itemstable">
          <tr class="greybg font-weight-bold ">
            <td class="pa-1 theadx">
              الصنف
              <br />
              Category
            </td>
            <td class="pa-1 theadx">
              اسم المادة<br />
              Item details
            </td>
            <td v-if="invoicetype === 'parts'" class="pa-1 theadx">
              سعر المادة<br />
              Unit price
            </td>
            <td v-if="invoicetype === 'parts'" class="pa-1 theadx">
              الكمية<br />
              Quantity
            </td>
            <td v-if="invoicetype === 'parts'" class="pa-1 theadx">
              مجموع المادة<br />
              Total per row
            </td>
          </tr>
          <tr v-for="(item, i) in items" :key="i" class="lightgrey">
            <td class="px-1 catitem">
              <strong id="smallfont"
                ><div>{{ item.cat_ar }}</div>
                <div>{{ item.cat_en }}</div></strong
              >
            </td>
            <td class="px-1">{{ item.title }}</td>
            <td v-if="invoicetype === 'parts'" class="px-1">
              ${{ item.unitprice }}
            </td>
            <td v-if="invoicetype === 'parts'" class="px-1">{{ item.quan }}</td>
            <td v-if="invoicetype === 'parts'" class="px-1">
              <strong>{{ item.itemtotal }}</strong>
            </td>
          </tr>
        </v-simple-table>
      </div>

      <div class="d-flex mt-4" id="totalflex">
        <div
          class="rtl font-weight-bold tablewidth flex-shrink-1 "
          id="totalflexdiv"
        >
          <v-simple-table id="totalflextable">
<!--            <tr>-->
<!--              <td>مجموع قيمة المواد</td>-->
<!--              <td class="text-left">${{ ordertotal }}</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td>التوصيل</td>-->
<!--              <td class="text-left">${{ ordershipping }}</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td>الخصم</td>-->
<!--              <td class="text-left">${{ orderdiscount }}</td>-->
<!--            </tr>-->
            <tr>
              <td colspan="2">
                <hr />
              </td>
            </tr>
<!--            <tr>-->
<!--              <td class="bigfootertext">الإجمالي</td>-->
<!--              <td class="text-left bigfootertext">${{ grandtotal }}</td>-->
<!--            </tr>-->
            <tr>
              <td class="bigfootertext">الإجمالي (بالدينار العراقي)</td>
              <td class="text-left bigfootertext">د.ع. {{ grandtotaliqd }}</td>
            </tr>
          </v-simple-table>
        </div>

        <div class="stamp mr-10 stampcontainer flex-grow-1">
          <v-img :src="stampurl" />
        </div>
      </div>

      <div class="my-4" id="footercontainer">
        <hr />
        <div class="d-flex justify-space-around rtl" id="footerflex">
          <div>{{ footeraddress }}</div>
          <div>{{ footeremail }}</div>
          <div>{{ footerfacebook }}</div>
          <div>{{ footerphone }}</div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { __HTTP, FormHeader } from "@/utils/utils";

export default {
  name: "Print",
  created() {
    this.getOrder();
  },
  components: {},
  methods: {
    getClientInfo() {
      if (this.clientdelivery === '1') {
        this.printto="معلومات الناقل"
        this.printnotes="معلومات الزبون"
      } else {
        this.printto="معلومات الزبون"
        this.printnotes="الملاحظات"
      }
    },
    getOrder() {
      __HTTP(
        "?do=print",
        JSON.stringify({ id: this.$route.query.id }),
        FormHeader,
        res => {
          //console.log(res);
          this.logourl = res.logourl;
          this.footerphone = res.footerphone;
          this.footeraddress = res.footeraddress;
          this.footerfacebook = res.footerfacebook;
          this.footeremail = res.footeremail;
          this.stampurl = res.stampurl;
          this.shippingmethod = res.shippingmethod;
          this.notes = res.notes;
          this.clientaddress = res.clientaddress;
          this.clientname = res.clientname;
          this.clientphone = res.clientphone;
          this.clientdelivery = res.clientdelivery;
          this.invoicedate = res.adddate;
          this.invoicenumber = res.id;
          this.ordertotal = res.total;
          this.ordershipping = res.ordershipping;
          this.orderdiscount = res.discount;
          this.grandtotal = res.grandtotal;
          this.grandtotaliqd = res.grandtotaliqd;
          this.items = res.items;
          this.invoicetype = res.invoicetype == "0" ? "pc" : "parts";
          this.getClientInfo()
          //setTimeout(() => this.print(),1000);
        }
      );

    }
  },
  data: () => ({
    invoicetype: "custompc",
    logourl: "",
    footerphone: "",
    footeraddress: "",
    footerfacebook: "",
    footeremail: "",
    stampurl: "",
    shippingmethod: "",
    notes: "",
    printto: "",
    printnotes: "",
    clientname: "",
    clientphone: "",
    clientaddress: "",
    clientdelivery: "",
    invoicedate: "",
    invoicenumber: "",
    ordertotal: "",
    ordershipping: "",
    orderdiscount: "",
    grandtotal: "",
    grandtotaliqd: "",
    items: [],
    printObj2: {
      id: "printMe2",
      popTitle: "Printing Page",
      extraCss: "https://iraquss.com/print.css?v=1",
      extraHead: '<meta http-equiv="Content-Language"content="ar-iq"/>'
    }
  })
};
</script>

<style>
.box {
  border: 2px solid #979797;
  direction: rtl;
}
.whitebg {
  background-color: #ffffff;
}
.greybg {
  background-color: #d8d8d8;
}
.lightgrey {
  background-color: #fafafa;
}
.whitebox {
  min-width: 300px;
}
.rtl {
  direction: rtl;
}
.printlogo {
  max-width: 200px;
  max-height: 100px;
}
.tablewidth {
  min-width: 300px;
}
.bigfootertext {
  font-size: larger;
}
.stamp {
  max-width: 160px;
  max-height: 160px;
}
#smallfont {
  font-size: 8px;
}
#itemstable td {
  height: 30px;
}
</style>
